export type ProfileTemplateSyncStatus = 'none' | 'pending' | 'synced';

type ProfileSyncFields = {
  profileTemplateSyncedRevision?: number | null;
  profileTemplateSyncPending?: boolean | null;
};

type TemplateRevisionFields = {
  revision?: number | null;
};

export function getProfileTemplateSyncStatus(
  profile: ProfileSyncFields | null | undefined,
  template: TemplateRevisionFields | null | undefined,
): ProfileTemplateSyncStatus {
  if (!template || !profile) {
    return 'none';
  }
  if (profile.profileTemplateSyncPending === true) {
    return 'pending';
  }
  const synced = profile.profileTemplateSyncedRevision;
  const revision = template.revision ?? 1;
  if (synced == null || synced < revision) {
    return 'pending';
  }
  return 'synced';
}
